function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M118.913 22.172V0L45.295 43.154l73.617 43.155V62.604c27 5.108 46.549 28.418 46.549 56.331 0 31.641-25.659 57.383-57.3 57.383S50.82 150.576 50.82 118.935a56.909 56.909 0 015.179-23.821L19.632 78.483c-5.825 12.743-8.774 26.354-8.774 40.452 0 53.697 43.688 97.383 97.385 97.383s97.218-43.686 97.218-97.383c0-49.996-37.548-91.306-86.548-96.763z"
});

var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9193A9",
    viewBox: "0 0 216.318 216.318"
  }, props), _ref);
};

export default SvgUndo;